<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card outlined>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Reimposta password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="user.email"
                label="Email"
                prepend-icon="fa-user"
                type="email"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <router-link :to="{ name: 'Login' }">
              Torna al login
            </router-link>
            <v-spacer />
            <v-btn depressed color="primary" @click="resetPassword">
              Richiedi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: null,
      },
    }
  },
  methods: {
    resetPassword() {
      this.$store
        .dispatch("resetPassword", this.user)
        .then((response) => {
          this.$store.commit("core/setSnack", {
            level: "success",
            msg: response.detail,
          })
          this.$router.push({ name: "Login" })
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          this.$store.commit("core/setSnack", {
            level: "error",
            msg: "Reset non riuscito.",
          })
          // console.log(err)
        })
    },
  },
}
</script>
